import DTSendCustomerPasswordResetThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTSendCustomerPasswordResetThenSendMacroNode/DTSendCustomerPasswordResetThenSendMacroNode';
import { getShowConfirmationPage } from '../../../selectors/tools';
import { useSelector } from 'react-redux';

const SendCustomerPasswordReset = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTSendCustomerPasswordResetThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'Password reset link has been sent.'}
    />
  );
};

export default SendCustomerPasswordReset;
